import { render, staticRenderFns } from "./ModifiersGroupModal.vue?vue&type=template&id=9688a60c&scoped=true&"
import script from "./ModifiersGroupModal.vue?vue&type=script&lang=js&"
export * from "./ModifiersGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./ModifiersGroupModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModifiersGroupModal.vue?vue&type=style&index=1&id=9688a60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9688a60c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VDialog})
